import styles from './hoardValues.module.css'
import { useDataTypesHooks } from '../../../../../features/data-types'
import { HoardOrder } from '../../../state/types'
import { useHoardHooks } from '../../../hooks/hoardHooks'

type Props = {
    hoard: HoardOrder
}

export const HoardValues = (props: Props) => {
    const { hoard } = props

    const { getUsedCredit, getPendingCredit } = useHoardHooks()
    const { formatPrice } = useDataTypesHooks()
    
    return (
        <div className={styles.container}>
            <div>Total: {formatPrice(hoard.value!)}</div>
            <div>Utilizado: {formatPrice(getUsedCredit(hoard.items))}</div>
            {!!hoard.unusedCredit && <div>No utilizado al cerrar: {formatPrice(hoard.unusedCredit)}</div>}
            <div>Restante: {formatPrice(getPendingCredit(hoard))}</div>
        </div>
    )
}
